import React, { FormEvent, useState } from "react";
import "./login-page.scss";
import InputField from "../../components/InputField/InputField";
import setInputValues from "../../utils/helpers/setInputValue";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useAppDispatch } from "../../store/storeRequests";
import useIdleTimout from "../../hooks/useIdleTimout";
import user from "../../assets/login/user.png";
import locked from "../../assets/login/locked.png";
import { useNotification } from "../../components/Alert/NotificationContext";
import APIList from "../../utils/constants/APIList";
import { postWithoutCredentials } from "../../services/http/http.service";
import StorageService from "../../services/storage/storage.service";
import { useNavigate } from "react-router-dom";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

const LoginPage: React.FunctionComponent = () => {
  const [loginCreds, setLoginCreds] = useState({ username: "", password: "" });

  const dispatch = useAppDispatch();
  const worker = useIdleTimout();
  const addNotification = useNotification();
  const navigate = useNavigate();

  const handleLogin = async (ev: FormEvent) => {
    ev.preventDefault();

    try {
      dispatch(showLoader('Loading data...'));
      const response = await postWithoutCredentials(APIList.ADMIN_LOGIN, {
        username: loginCreds.username,
        password: loginCreds.password,
      });

      console.log("LOGIN resopnse",response)

      if(response.status === 401){
        setLoginCreds({ username: "", password: "" })
        dispatch(showToast("Invalid Credentials"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return
      }

      else if(response.data.status === "Failed"){
        dispatch(showToast(response.data.message));
        setTimeout(() => dispatch(hideToast()), 3000);
      }

      else if(response.statusCode === 200){
        
              StorageService.setToStorage({ user: { token: response.data } });
              navigate("/");
        
              dispatch(showToast("Logged In Successfully !!!"));
              setTimeout(() => dispatch(hideToast()), 3000);
              console.log("ADMIN logged in", response);
       
       }
       else{
        dispatch(showToast("An unexpected error occurred while loggin in."));
        setTimeout(() => dispatch(hideToast()), 3000);
       }

    } catch (error) {
      console.error('Error fetching data:', error);
      dispatch(showToast("An error occurred while loggin in."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleDelete = () => {
    const userConfirmed = window.confirm("Are you sure you want to delete?");
    if (userConfirmed) {
      console.log("Item deleted");
      addNotification("Item successfully deleted!", "Success", "Success");
    } else {
      console.log("Item not deleted");
    }
  };

  return (
    <div className="mf-admin-login bg-wallpaper w-100 d-flex align-items-center justify-content-center">
      <div className="main-container">
        <div className="flex-container d-flex justify-content-center gap-2 ">
          <div className="left text-black fs-6 text-start">
            <h1 className="fs-2 mb-3 fw-bold">As One</h1>
            <h5 className="font-14 fw-bold mb-4" style={{fontFamily: "serif"}}>
              Welcome to As One Admin Panel
            </h5>
            <ul className="font-14 fw-medium mb-4 list">
              <li className="font-lato">Interact with Employee</li>
              <li className="font-lato">Give Feedback</li>
              <li className="font-lato">Invite Contacts</li>
              <li className="font-lato">Social Sharing</li>
              <li className="font-lato">and much more...</li>
            </ul>
            <h4 className="font-18 fw-semibold">Disclaimer</h4>
            <h5 className="font-14 fw-semibold">
              Admin Panel works best on Google Chrome & Mozilla Firefox
            </h5>
          </div>

          <div className="login-form-container">
            <form className="login-form" onSubmit={handleLogin}>
              <div className=" input-fields-container d-flex align-items-center justify-content-center font-lato">
                <div className="input-field-wrapper position-relative">
                  <InputField
                    name="username"
                    type="text"
                    value={loginCreds.username}
                    placeholder="username"
                    minLength={3}
                    maxLength={50}
                    required={true}
                    className="font-lato"
                    onChangeInput={(ev) =>
                      setInputValues(ev, loginCreds, setLoginCreds)
                    }
                  />
                  <span className="input-field-icon">
                    <img src={user} alt="user-icon" />
                  </span>
                </div>
                <div className="input-field-wrapper position-relative">
                  <InputField
                    name="password"
                    type="password"
                    value={loginCreds.password}
                    placeholder="password"
                    required={true}
                    className="font-lato"
                    onChangeInput={(ev) =>
                      setInputValues(ev, loginCreds, setLoginCreds)
                    }
                  />
                  <span className="input-field-icon">
                    <img src={locked} alt="lock-icon" />
                  </span>
                </div>
              </div>

              <div className="submit-button-wrapper d-flex align-items-center justify-content-center font-lato">
                <CustomButton type="submit" size="md" theme="red">
                  Submit
                </CustomButton>
              </div>
            </form>
          </div>
        </div>
        <hr className="line" />
        <div className="footer font-12 text-black fw-medium text-start ">
          <p className="font-lato">&copy; {new Date().getFullYear()}. All Rights Reserved. As One</p>
        </div>
      </div>

      {/* <ToastNotification show={showToastState} onClose={() => setShowToastState(false)} message="Item successfully deleted!" /> */}
    </div>
  );
};

export default LoginPage;
